import ActionItemRegistry from './registry';

ActionItemRegistry.register({ 
    itemType: [
        "wca-sync-error",      
    ],
    component: "WcaSyncError",
    buttons: "Done"
});



// WEBPACK FOOTER //
// ./src/action-items/types/wca-sync-error-items.js